import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/agencies';
const AGENCY_IDENTIFIERS_BASE = '/api/agency_identifiers';

export default {
  getByAgencyId: (agencyId) => getApiUrl(`${BASE}/${agencyId}/identifiers`),
  create: (agencyId) => getApiUrl(`${BASE}/${agencyId}/identifiers`),
  update: (agencyId, identifierId) => getApiUrl(`${BASE}/${agencyId}/identifiers/${identifierId}`),
  getAgencyIdentifiers: () => getApiUrl(AGENCY_IDENTIFIERS_BASE),
  previewIdentifier: () => getApiUrl(`/api/mission_control/agencies/iatas/preview`),
};
